import React, {Component} from "react";
import { Bar } from 'react-chartjs-2';
import ReactToPrint from "react-to-print";
import FeatherIcon from 'feather-icons-react';
import UserIdentity from "../../users/UserIdentity";
import { Chart, registerables } from 'chart.js'
import Headerpdf from "../../users/Headerpdf";
import { getThemeColor } from "../../../theme/branding";
Chart.register(...registerables)

const createDataset = (data, color = getThemeColor()) => ({
  label: 'Données',
  backgroundColor: `${color}cc`,
  borderColor: color,
  hoverBackgroundColor: color,
  borderWidth: 2,
  data
});

class StudentBar extends Component{

    state = {
        labels: ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
        datasets: [createDataset([47, 35, 66, 52, 33, 44, 20, 66, 12, 22, 44, 59])]
      }

      componentDidMount(){
        window.addEventListener("evivesoma:theme", this.handleThemeChange);

        if(this.props.data)
        {
          this.setState({
              data : this.props.data,
              datasets: [createDataset(this.props.data)]
          })
        }

        if(this.props.labels)
        {
          this.setState({
            labels : this.props.labels
          })
        }
      }

      componentWillUnmount(){
        window.removeEventListener("evivesoma:theme", this.handleThemeChange);
      }

      handleThemeChange = (event) => {
        const color = event.detail || getThemeColor();
        this.setState((state) => ({
          datasets: state.datasets.map((dataset) => createDataset(dataset.data, color))
        }));
      }

    render(){
        return(
            <div>
                <div className="text-end">
                    <ReactToPrint
                        trigger={() => (
                            <button
                                className="btn btn-sm btn-primary d-inline-flex align-items-center gap-2 rounded-3 px-3"
                                type="button"
                                title="Imprimer le graphique"
                            >
                                <FeatherIcon icon="printer" size="17" />
                                <span>Imprimer</span>
                            </button>
                        )}
                        content={() =>  this.componentRef}
                    />
                </div>
                <div ref={el => (this.componentRef = el)}>
                  <Headerpdf />
                    {
                       <UserIdentity matricule ={this.props.matricule} name={this.props.name} classe={this.props.classe} title={this.props.title}/> 
                    }
                    <Bar
                        data={this.state}
                        options={{
                        plugins: {
                            title: {
                            display: true,
                            text: "Données"
                            },
                            legend: {
                            display: true,
                            position: "bottom"
                        }
                        }
                        }}
                    />
                </div>

            </div>
        )
    }
}
export default StudentBar;
